<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Needs Work'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">


    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Please help us learn more about what went wrong with'" /><span>&nbsp;</span>
          <tidy-text
            [body]="hkName + '.'" /><span>&nbsp;</span>
            <tidy-text
              [body]="'Our Concierge will review and email you ASAP.'" />
          </tidy-row>
          @if (loaded) {
            <form [formGroup]="feedbackForm">
              @if (answers['what_happened.didnt_finish'] === 't') {
                <tidy-card>
                  <tidy-row>
                    <tidy-text
                      [header]="'Didn’t Finish To Dos'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="'What was the main reason they didn’t finish?'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-radio-button
                      (optionChange)="setDidntFinish($event)"
                      [items]="finishTypes" />
                  </tidy-row>
                  @if (didntFinish === 'didnt_finish.didnt_stay.arrived_at') {
                    <tidy-two-column-row style="padding-top: 20px;">
                      <tidy-select
                        style="max-width: 35%; margin: 0;"
                        [icon]="'assets/svg/time.svg'"
                        [label]="'Arrived at'"
                        [form]="feedbackForm.controls['didnt_finish.didnt_stay.arrived_at']"
                        formControlName="didnt_finish.didnt_stay.arrived_at"
                        (optionChange)="updateDidntFinish('didnt_finish.didnt_stay.arrived_at', $event)"
                        [items]="timeOpts" />
                      <span style="align-self: center; justify-content: space-around; max-width: 10%;">-</span>
                      <tidy-select
                        style="max-width: 35%; margin-right: 10px;"
                        [icon]="'assets/svg/time.svg'"
                        [label]="'Left at'"
                        [form]="feedbackForm.controls['didnt_finish.didnt_stay.left_at']"
                        (optionChange)="updateDidntFinish('didnt_finish.didnt_stay.left_at', $event)"
                        [items]="timeOpts" />
                    </tidy-two-column-row>
                  }
                </tidy-card>
              }
              @if (answers['what_happened.bad_ability'] === 't') {
                <tidy-card>
                  <tidy-row>
                    <tidy-text
                      [header]="'Abilities'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="'Rate'" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="hkName + ('\'s ability (1-5 stars):' | translate)" />
                    </tidy-row>
                    <tidy-row class="vertical-align-center">
                      <tidy-grid>
                        <ion-row>
                          @for (star of stars; track star; let i = $index) {
                            <ion-col size="2" style="margin-right:5px">
                              <tidy-image
                                [src]="'assets/svg/' + (i < rating ? 'star-tidy-green' : 'star-grey') + '.svg'"
                                [ngClass]="i < rating ? 'green' : 'grey'"
                                (click)="setStarRate(i)"
                                class="title-size" />
                            </ion-col>
                          }
                        </ion-row>
                      </tidy-grid>
                    </tidy-row>
                    <tidy-text
                      [helper]="starMessage(feedbackForm.value['bad_ability.star_rating'])" />
                  </tidy-card>
                }
                @if (answers['what_happened.bad_supplies'] === 't' && isCleaningJob) {
                  <tidy-card>
                    <tidy-row>
                      <tidy-text
                        [header]="'Missing Supplies'" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-text
                        [body]="'Was'" /><span>&nbsp;</span>
                        <tidy-text
                          [body]="hkName" /><span>&nbsp;</span>
                          <tidy-text
                            [body]="'missing supplies? Select all that apply:'" />
                        </tidy-row>
                        @for (key of badSuppKeys[0]; track key) {
                          <tidy-checkbox
                            [formControlName]="key"
                            [form]="feedbackForm.controls.key"
                            [items]="[{viewValue: badSupp[key] , value: true}]" />
                        }
                        <tidy-row class="extra-top-padding">
                          <tidy-divider />
                        </tidy-row>
                        <tidy-row class="extra-top-padding">
                          <tidy-text
                            [body]="'Were there other issues with their supplies?'" />
                        </tidy-row>
                        @for (key of badSuppKeys[1]; track key) {
                          <tidy-checkbox
                            [formControlName]="key"
                            [form]="feedbackForm.controls.key"
                            [items]="[{viewValue: badSupp[key] , value: true}]" />
                        }
                      </tidy-card>
                    }
                    @if (answers['what_happened.bad_attitude'] === 't') {
                      <tidy-card>
                        <tidy-row>
                          <tidy-text
                            [header]="'Unprofessional Attitude'" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-text
                            [body]="'How was'" /><span>&nbsp;</span>
                            <tidy-text
                              [body]="hkName" /><span>&nbsp;</span>
                              <tidy-text
                                [body]="'unprofessional?'" />
                            </tidy-row>
                            @for (key of badAttitudeKeys; track key) {
                              <tidy-checkbox
                                [formControlName]="key"
                                [form]="feedbackForm.controls.key"
                                [items]="[{viewValue: badAttitude[key] , value: true}]" />
                            }
                          </tidy-card>
                        }
                        @if (answers['what_happened.serious_issue'] === 't') {
                          <tidy-card>
                            <tidy-row>
                              <tidy-text
                                [header]="'Safety Issue'" />
                            </tidy-row>
                            <tidy-row class="extra-bottom-padding">
                              <tidy-text
                                [body]="'What was the safety issue?'" />
                            </tidy-row>
                            <tidy-row>
                              <tidy-textarea
                                formControlName="serious_issue"
                                [label]="hkName + (' will not see this' | translate)"
                                [form]="feedbackForm.controls.serious_issue"
                                [errorMessage]="'Please enter a valid gift code.'"
                                [icon]="'assets/svg/alert-circle-outline.svg'" />
                            </tidy-row>
                          </tidy-card>
                        }
                        <tidy-card>
                          <tidy-row>
                            <tidy-text
                              [header]="'Block'" /><span>&nbsp;</span>
                              <tidy-text
                                [header]="hkName + '?'" />
                            </tidy-row>
                            <tidy-row class="extra-bottom-padding">
                              <tidy-text
                                [body]="'Would you have'" /><span>&nbsp;</span>
                                <tidy-text
                                  [body]="hkName" /><span>&nbsp;</span>
                                  <tidy-text
                                    [body]="'again?'" />
                                </tidy-row>
                                <tidy-radio-button
                                  formControlName="blacklist_hk"
                                  [form]="feedbackForm.controls.blacklist_hk"
                                  [errorMessage]="'Please enter a valid gift code.'"
                                  [items]="[{viewValue: 'Yes, I think they can get it next time', value: false},{viewValue: 'No, I don’t want them again', value: true}]"
                                  class="no-margin-first" />
                              </tidy-card>
                              <tidy-card>
                                <tidy-row>
                                  <tidy-text
                                    [header]="'Constructive Feedback'" />
                                </tidy-row>
                                <tidy-row class="extra-bottom-padding">
                                  <tidy-text
                                    [body]="'Give' + ' '" />
                                  <tidy-text
                                    [body]="hkName + ' '" />
                                  <tidy-text
                                    [body]="'Constructive Feedback (optional)'" />
                                </tidy-row>
                                <tidy-row>
                                  <tidy-textarea
                                    formControlName="constructive_feedback"
                                    [label]="'Goes directly to them.'"
                                    [form]="feedbackForm.controls.constructive_feedback"
                                    [errorMessage]="'Please enter feedback.'"
                                    [icon]="'assets/svg/person-circle-outline.svg'" />
                                </tidy-row>
                              </tidy-card>
                              <tidy-error-message
                                [text]="errorMessage" />
                              <tidy-button
                                [text]="'Next'"
                                [action]="boundSendFeedback"
                                class="primary" />
                            </form>
                          }
                        }
                      </tidy-wrapper>
                    </ng-template>

                    @if (!isRightSideContent) {
                      <app-scroll-wrapper [templateContent]="content" />
                    }

                    @if (isRightSideContent) {
                      <ion-content class="ion-content-right-column">
                        <ng-container *ngTemplateOutlet="content" />
                      </ion-content>
                    }
